(function () {
    'use strict';

    angular
        .module('navigationControllers')
        .controller('NavigationController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$modal', '$q','$location', '$timeout','searchService', 'searchV2Service', 'authService'];

    function Controller($rootScope, $scope, $state, $modal, $q, $location, $timeout, searchService, searchV2Service, authService) {

        var MAX_DISPLAYED_RESULTS = 10;

        $scope.searchCtx = {};
        $scope.facetConfiguration = {};
        $scope.hierarchicalFacetCtx = {};
        $scope.refineFacetCtx = {};
        $scope.searchResultsCtx = {};
        $scope.searchResultsCtx.maxDisplayedResults = MAX_DISPLAYED_RESULTS;


        $rootScope.$on('$stateChangeSuccess', function () {
            $scope.searchCtx.isHome = $state.is('home');
            $scope.searchCtx.isAdvancedSearch = $state.is('advancedSearch');
        });

        // Update location search
        $scope.updateLocationSearch = function () {
            $location
                .search({
                    q: $scope.searchCtx.q,
                    h: _.map($scope.hierarchicalFacetCtx.levels, 'instanceFacetId'),
                    r: _.map($scope.refineFacetCtx.selected, function (columnValue, refineFacetId) {
                        return refineFacetId + ',' + columnValue;
                    })
                })
                .replace();
        };

        var requestTimeout;

        $scope.ctxNav = {};
        $scope.ctxNav.isDirty = false;

        // Add class on <body> to disable main scrollbar when spotlight is open
        var bodyEl = document.querySelector('body');
        $scope.$watch('searchCtx.searchSuggestions', function (newVal) {
            // Don't use toggle(class, force) as IE11 does not support second parameter
            if (newVal) {
                bodyEl.classList.add('spotlight-open');
            } else {
                bodyEl.classList.remove('spotlight-open');
            }
        });

        // Hide results
        $scope.hideSuggestions = function () {
            $scope.searchEnabled = false;
            $scope.searchCtx.isLeftBarOpen = false;
            $scope.searchCtx.searchSuggestions = false;
        };

        // Input Search Field Blurred
        $scope.inputBlurred = function () {
            $scope.ctxNav.searchInputFocused = false;

            // Wait as user may have clicked the scrollbar in the suggestions which triggers the blur
            // but shouldn't close the suggestions (IE11).
            $timeout(function () {

                if (!$scope.ctxNav.suggestionsFocused) {
                    $scope.searchEnabled = false;
                    $scope.searchCtx.isLeftBarOpen = false;
                    $scope.searchCtx.searchSuggestions = false;
                }
            }, 100);
        };

        // Suggestions gained focus
        $scope.suggestionsFocused = function () {
            $scope.ctxNav.suggestionsFocused = true;
        };

        // Suggestions lost focus
        $scope.suggestionsBlurred = function () {
            $scope.ctxNav.suggestionsFocused = false;

            // Wait to make sure user didn't click in the input search field again
            $timeout(function () {
                if (!$scope.ctxNav.searchInputFocused) {
                    $scope.hideSuggestions();
                }
            }, 100);
        };

        // Search function
        $scope.search = function (q) {
            $scope.ctxNav.searchInputFocused = true;

            $scope.searchEnabled = true;

            if (q === undefined || q === '') {
                $scope.searchCtx.isLeftBarOpen = true;
                $scope.searchCtx.searchSuggestions = false;
                return;
            }

            //Start showing results as they come in
            $scope.searchCtx.searchSuggestions = !$state.is('advancedSearch');

            if (requestTimeout) {
                requestTimeout.resolve('New search query, current requests cancelled');
            }
            requestTimeout = $q.defer();


            if (q.length >= 0) {
                $scope.searchCtx.isSearching = true;
                $scope.searchCtx.isLoading = true;


                searchV2Service
                    .initializeSearch([
                                        'Employee',
                                        'Procedure',
                                        'BusinessUnit',
                                        'Committee',
                                        'AuditMandate',
                                        'GlossaryTerm',
                                        'CorporateRole',
                                        'Control',
                                        'Risk',
                                        'RiskEvent',
                                        'PlanInitiative',
                                        'RecomActionPlan',
                                        'Recommendation',
                                        'BIAProfile'],{
                                                q: q
                                        })
                    .then(function (searchCtxt) {

                        if ($state.is('advancedSearch')) {
                            $scope.searchCtx.searchCtxt = searchCtxt;
                        } else {
                            $scope.searchCtx.dropdownSearchCtxt = searchCtxt;
                        }

                        $scope.searchCtx.hasResults = false;
                        _.some(searchCtxt.sources, function (source) {
                            if (source.numFound > 0) {
                                $scope.searchCtx.hasResults = true;
                                return true;
                            }
                            return false;
                        });

                    });

            } else {
                reset();
            }

            if (!$scope.$$phase) $scope.$apply();
        };

        $scope.clearSearchState = function () {
            $scope.searchCtx.q = '';
            $scope.searchCtx.isSearching = false;
            $scope.searchCtx.isLoading = false;
            $scope.searchCtx.searchSuggestions = false;
            $scope.searchEnabled = false;
            $scope.searchCtx.isLeftBarOpen = false;
            $state.go('home',{ UserItemPersonID: $scope.authenticatedUser.ItemPersonID }, { reload: true });
        };

        // toggle or untoggle category and action menu
        $scope.toggleSourceSelection = function (sourceType) {

            if (!$scope.searchCtx.q) {
                $scope.searchCtx.q = '*';
            }
            $scope.searchCtx.isSearching = true;
            $scope.searchCtx.isLoading = true;
            var params;
            if (sourceType.sourceType === "") {
                params = {
                    q: '*',
                    n: 18, // Return Maximum
                    withHighlighting: true
                }
            }
            else {
                params = {
                    q: '*',
                    sourceType: sourceType.sourceType,
                    n: 18, // Return Maximum
                    withHighlighting: true
                }
            }

            //Use the new service to return the data
            searchV2Service
                .initializeSearch([
                                   'Employee',
                                   'Procedure',
                                   'BusinessUnit',
                                   'Committee',
                                   'GlossaryTerm',
                                   'CorporateRole',
                                   'Control',
                                   'Risk',
                                   'RiskEvent',
                                   'PlanInitiative',
                                   'RecomActionPlan',
                                   'Recommendation',
                                   'BIAProfile'],
                                    params)
                .then(function (searchCtxt) {
                    $scope.searchCtx.searchCtxt = searchCtxt;
                });

            $scope.updateLocationSearch();

            if (!$scope.$$phase) $scope.$apply();

        };

        $scope.showSearchBoxTrigger = function () {
            return !$state.is('home') && !$state.is('search') && !$state.is('businessPlanExplorer');
        };

        $scope.hasUserSearchAccess = function () {
            return !!$scope.authenticatedUser;
        };

        $scope.logout = function () {
            authService.logout();
        };

        $scope.showSearchBoxTriggerModal = function () {

            // When page is not dirty (all data are saved)
            if (!$scope.ctxNav.isDirty) {
                $state.go('search');
            }

            // When page is dirty (all data are not saved)
            else {
                var modalScope = $scope.$new(true);

                var searchBoxTriggerModal = $modal({
                    scope: modalScope,
                    template: '/app/shared/searchBox/searchBoxTriggerModal.tpl.html',
                    placement: 'center'
                });

                modalScope.hideModal = function () {
                    searchBoxTriggerModal.$promise.then(searchBoxTriggerModal.hide);
                };

                modalScope.okModal = function () {
                    modalScope.hideModal();
                };
            }
        };

        $scope.$on('page-is-dirty', function () {
            $scope.ctxNav.isDirty = true;
        });

        $scope.$on('page-is-not-dirty', function () {
            $scope.ctxNav.isDirty = false;
        });

    }
})();
